<script lang="ts">
	interface Props {
		label: string
		href?: string
		download?: string
		target?: string
		onclick?: () => Promise<void>
		class?: string
	}

	let { label, href, download, target, onclick, class: className = '' }: Props = $props()
</script>

{#if onclick}
	<button
		type="button"
		{onclick}
		class="{className} tw:w-full tw:text-start tw:border-0 tw:text-plum tw:bg-white tw:block tw:px-4 tw:py-2 tw:text-sm tw:hover:bg-lilac tw:hover:!text-white tw:font-medium"
		role="menuitem">{label}</button>
{:else}
	<a
		{href}
		{download}
		{target}
		class="{className} tw:block tw:px-4 tw:py-2 tw:text-sm tw:hover:bg-lilac tw:hover:!text-white tw:font-medium"
		role="menuitem"
		tabindex="-1">{label}</a>
{/if}
